<template>
    <div>
        <mensajeSistema></mensajeSistema>
        
        <div v-if="test">  
            
            ComponenteGeneral : {{estadoComponenteGeneral  }}, 
            ComponenteGeneral : {{ estadoComponenteCompra }}, 
            ComponenteGeneral : {{ estadoComponenteVenta }},
            ComponenteGeneral : {{ estadoComponenteCxC }}, 

        </div>
        <v-row>

            <v-col>
                <v-tabs mr-5 dark color="#ffbc00" background-color="color_secondary">
                    <v-tab class="font-weight-black" @click="getControlGeneral()">Control general</v-tab>
                    <v-tab class="font-weight-black" @click="getControlCompra()">Control de compras</v-tab>
                    <v-tab class="font-weight-black" @click="getControlVenta()">Control de ventas</v-tab>
                    <v-tab class="font-weight-black" @click="getControlCxC()">Control CxC</v-tab>

                    <!--  ITEMS GENERAL -->
                    <v-tab-item>
                        <component :is="compNameGeneral" :estadoComp="estadoComponenteGeneral" :parametros="parametroComp" 
                            @reloadComp="reloadComp" @close="estadoComponenteGeneral=false" >
                        </component>        
                    </v-tab-item>

                    <!--  ITEMS COMPRA -->
                    <v-tab-item> 
                        <component :is="compNameCompra" :estadoComp="estadoComponenteCompra" :parametros="parametroComp" 
                            @reloadComp="reloadComp" @close="estadoComponenteCompra=false">
                        </component>
                    </v-tab-item>

                    <!--  ITEMS VENTA -->
                    <v-tab-item> 
                        <component :is="compNameVenta" :estadoComp="estadoComponenteVenta" :parametros="parametroComp" 
                            @reloadComp="reloadComp" @close="estadoComponenteVenta=false" >
                        </component>
                    </v-tab-item>


                    <!--  ITEMS CxC -->
                    <v-tab-item> 
                        <component :is="compNameCxC" :estadoComp="estadoComponenteCxC" :parametros="parametroComp" 
                            @reloadComp="reloadComp" @close="estadoComponenteCxC=false" >
                        </component>
                    </v-tab-item>
                    

                </v-tabs>
            </v-col>
        </v-row>

    </div>
</template>



<script>

    import {mapMutations, mapGetters} from 'vuex';

    import ControlGeneralComp from '@/views/WebSystem/Sistema/Configuracion/ControlGeneral.vue'
    import ControlCompraComp from '@/views/WebSystem/Sistema/Configuracion/ControlCompra.vue'
    import ControlVentaComp from '@/views/WebSystem/Sistema/Configuracion/ControlVenta.vue'
    import ControlCxCComp from '@/views/WebSystem/Sistema/Configuracion/ControlCxC.vue'
    export default {
        name:'configuracionSistema',

        components:{
            ControlGeneralComp,           
            ControlVentaComp,
            ControlCompraComp,
            ControlCxCComp
        },

        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{  "id_modulo": 1000, "id_submodulo":1000 }, //sud_modulo y modulo
            session: sessionStorage, // variables de sesion del usuario
            test:false,
            ////////////////////////////////////////////////////////

            // componentes            
            compNameGeneral: null,
            estadoComponenteGeneral : false,
            parametroComp : [],

            compNameVenta: null,
            estadoComponenteVenta : false,

            compNameCompra: null,
            estadoComponenteCompra : false,

            compNameCxC: null,
            estadoComponenteCxC : false,

        }),



        computed: {
            ...mapGetters('login', [ 'componenteEvento']),
        },


        mounted() {
            this.loadMain()
        },

        /*
        created(){
            this.actualizarParamentro()
        },
        */


        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            //----- Validar accesos por perfil ------------
           //  ...mapActions('login',['parametroComponente'] ),

            /*
            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },
            */
            ////////////////////////////////////////////////////////

            loadMain(){

                if(this.session.id_sucursal === undefined  || this.session.id_sucursal == "" || this.session.id_sucursal == "undefined" ) {
                    this.setEnviarMens({tipo:'E', mensaje: `No se pudo seleccionar la sucursal`, tiempo:null})
                    return false
                }
                this.getControlGeneral()
            },
        
            getControlGeneral(){

                this.limpiarForm()
                this.compNameGeneral         = "ControlGeneralComp"                
                this.estadoComponenteGeneral = true
                this.parametroComp           = {}
            },
           
            getControlCompra(){
                this.limpiarForm()
                this.compNameCompra         = "ControlCompraComp"
                this.estadoComponenteCompra = true               
                this.parametroComp          = {}
            },

            getControlVenta(){
                this.limpiarForm()
                this.compNameVenta          = "ControlVentaComp"
                this.estadoComponenteVenta  = true               
                this.parametroComp          = {}
            },

            getControlCxC(){
                this.limpiarForm()
                this.compNameCxC          = "ControlCxCComp"
                this.estadoComponenteCxC  = true               
                this.parametroComp          = {}
            },

            reloadComp(procedencia){
                console.debug(procedencia)  
                this.limpiarForm()
                this.loadMain()
                
            },

    
            limpiarForm(){

                this.estadoComponenteGeneral = false
                this.estadoComponenteCompra  = false
                this.estadoComponenteVenta   = false
                this.estadoComponenteCxC     = false
            },


        },
    }
</script>